module.exports = __webpack_public_path__ + "img/128.689d8786.png";